//detail page-1 of Live reply

import React from 'react'
import "./Resources.css"

const Live_1 = () => {
  return (
   <>
   <div id="live1">

<h1><b>Marketing Yourself Before and AFTER You Get the Job</b></h1>
<br/>
<br/>
<video width="100% " controls autoplay>
      <source src="https://youtu.be/x0q3dZ1TtIc"  type="video/mp4" />

     </video>
     

     
     <br/>
     <br/>
     <br/>
     <br/>
     <p style={{fontSize:"20px"}}>How do I impress my boss? There’s inherent bias in hiring? Navigating the Glass Ceiling (still exists)! The dreaded cover letter….
<br/>
<br/>
On this edition of Lately Live, HR Queen and founder of Self-Made Millennial, Madeline Mann helps us strategize the BEST ways to tackle the beast that is our working life. Whether you're a seasoned professional or new to joining the work world, Madeline will answer all questions on getting, keeping and changing your job!
<br/>
Suddenly have A LOT of questions? Yeah, so do we :-).
<br/>
<br/>
‍Madeline Mann is the founder of Self-Made Millennial (500,000+ subscribers and counting!), a group of content channels that spans all social media platforms and provides rapid-fire, battle-tested career advice, resulting in thousands of powerful testimonials and success stories. Recently, Madeline was named a Top 50 Person to Follow on LinkedIn and she’s also a LinkedIn Learning Instructor seasoned career coach. Self-Made Millennial has been featured on Bloomberg, The New York Times and Forbes and named a Top 10 YouTube Channel for Job Seekers.

</p>
<br/>
<br/>
<br/>
<a href='https://youtu.be/x0q3dZ1TtIc' target="_blank">Back to Lately LIVE Videos
</a>
   </div>
   </>
  )
}

export default Live_1